"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModuleAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const _contracts_1 = require("../modules/_contracts");
const front_1 = require("../modules/front");
/**
 * Associates the ModuleDrivers with the applicable adapters.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
// @ts-expect-error
const adaptersRegistry = {
    [_contracts_1.SimpleModuleDriver.AdBanner]: new front_1.AdBannerAdapter(),
    [_contracts_1.SimpleModuleDriver.Blockquote]: new front_1.BlockquoteAdapter(),
    [_contracts_1.SimpleModuleDriver.DataSet]: new front_1.DataSetAdapter(),
    [_contracts_1.SimpleModuleDriver.Embed]: new front_1.EmbedAdapter(),
    [_contracts_1.SimpleModuleDriver.Form]: new front_1.RequestAccessAdapter(),
    [_contracts_1.SimpleModuleDriver.Gallery]: new front_1.GalleryAdapter(),
    [_contracts_1.SimpleModuleDriver.Heading]: new front_1.HeadingAdapter(),
    [_contracts_1.SimpleModuleDriver.HR]: new front_1.HRAdapter(),
    [_contracts_1.SimpleModuleDriver.HTML]: new front_1.HTMLAdapter(),
    [_contracts_1.SimpleModuleDriver.Image]: new front_1.ImageAdapter(),
    [_contracts_1.SimpleModuleDriver.Legacy]: new front_1.HTMLAdapter(),
    [_contracts_1.SimpleModuleDriver.List]: new front_1.ListAdapter(),
    [_contracts_1.SimpleModuleDriver.Paragraph]: new front_1.ParagraphAdapter(),
    [_contracts_1.SimpleModuleDriver.Paywall]: new front_1.PaywallAdapter(),
    [_contracts_1.SimpleModuleDriver.ReadMore]: new front_1.ReadMoreAdapter()
};
/**
 * Associates the ModuleDrivers with the applicable TokenTypes.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const tokensRegistry = {
    [_contracts_1.SimpleModuleDriver.AdBanner]: [demarked_1.TokenType.AdBanner],
    [_contracts_1.SimpleModuleDriver.Blockquote]: [demarked_1.TokenType.Blockquote],
    [_contracts_1.SimpleModuleDriver.DataSet]: [demarked_1.TokenType.DataSet],
    [_contracts_1.SimpleModuleDriver.Embed]: [demarked_1.TokenType.Embed, demarked_1.TokenType.EmbedYouTube, demarked_1.TokenType.EmbedPdf, demarked_1.TokenType.EmbedTwitter, demarked_1.TokenType.EmbedVideo, demarked_1.TokenType.EmbedVideoSwitch],
    [_contracts_1.SimpleModuleDriver.Form]: [demarked_1.TokenType.Form],
    [_contracts_1.SimpleModuleDriver.Gallery]: [demarked_1.TokenType.Gallery],
    [_contracts_1.SimpleModuleDriver.Heading]: [demarked_1.TokenType.Heading],
    [_contracts_1.SimpleModuleDriver.HR]: [demarked_1.TokenType.HR],
    [_contracts_1.SimpleModuleDriver.HTML]: [demarked_1.TokenType.HTML],
    [_contracts_1.SimpleModuleDriver.Image]: [demarked_1.TokenType.Image],
    [_contracts_1.SimpleModuleDriver.Legacy]: [demarked_1.TokenType.HTML],
    [_contracts_1.SimpleModuleDriver.List]: [demarked_1.TokenType.List],
    [_contracts_1.SimpleModuleDriver.Paragraph]: [demarked_1.TokenType.Paragraph],
    [_contracts_1.SimpleModuleDriver.Paywall]: [demarked_1.TokenType.Paywall],
    [_contracts_1.SimpleModuleDriver.ReadMore]: [demarked_1.TokenType.ReadMore]
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class SimpleModuleAdapter {
    constructor() {
        this.adaptersRegistry = adaptersRegistry;
        this.tokensRegistry = tokensRegistry;
    }
    /**
     * Adapts (translates/maps) the passed-in module object to `Token`.
     *
     * @param object - The object to adapt.
     * @param storage
     */
    objectToToken(object, storage) {
        const adapter = this.adaptersRegistry[object.driver];
        if (typeof adapter === 'undefined') {
            throw new Error(`Adapter.objectToToken(): No Adapter was found for the given driver!\nObject: ${JSON.stringify(object)}`);
        }
        return adapter.objectToToken(object, storage);
    }
    /**
     * Adapts (translates/maps) the passed-in `Token` to module object.
     *
     * @param token - The Token to adapt.
     * @param storage
     */
    tokenToObject(token, storage) {
        let driver;
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const drivers = Object.values(_contracts_1.SimpleModuleDriver);
        for (const _driver of drivers) {
            if (Object.prototype.hasOwnProperty.call(this.tokensRegistry, _driver)) {
                if (this.tokensRegistry[_driver].includes(token.type)) {
                    driver = _driver;
                    break;
                }
            }
        }
        if (typeof driver === 'undefined') {
            throw new Error(`Adapter.tokenToObject(): No driver was found for the given token!\nToken: ${JSON.stringify(token)}`);
        }
        const adapter = this.adaptersRegistry[driver];
        if (typeof adapter === 'undefined') {
            throw new Error(`Adapter.tokenToObject(): No Adapter was found for the given token!\nToken: ${JSON.stringify(token)}`);
        }
        return adapter.tokenToObject(token, storage);
    }
}
exports.SimpleModuleAdapter = SimpleModuleAdapter;
//# sourceMappingURL=SimpleModuleAdapter.js.map